import { RESEARCH_RESULTS_ENTRY_TYPES } from '@/config/research';

function getStageKey(columns) {
  return columns.find((field) => field.type === RESEARCH_RESULTS_ENTRY_TYPES.STAGE)?.key;
}

function notUndefinedOrNull(value) {
  return ![undefined, null].includes(value);
}

function getSource(cell) {
  const source = cell.source ?? cell;
  return {
    ...source,
    value: source.override ? source.valueBeforeOverride : source.value,
  };
}

function getContext({ row, stageKey, results }) {
  return {
    results,
    subject: null,
    stage: row[stageKey] || null,
  };
}

function formatRowForRendering(rows, columns, results = null) {
  const stageKey = getStageKey(columns);
  return rows.map((row) => {
    return columns
      .map((column) => {
        const cell = row[column.key];
        if (column.key === 'comment') return { ...cell, key: column.key };

        return {
          key: column.key,
          value: cell.value,
          hasOldValue:
            notUndefinedOrNull(cell.value) && notUndefinedOrNull(cell.oldValue) && cell.oldValue !== cell.value,
          hasOverride: notUndefinedOrNull(cell.override),
          source: getSource(cell),
          context: getContext({
            row,
            stageKey,
            results,
          }),
          entryDataId: cell.entryDataId,
          oldValue: notUndefinedOrNull(cell.override) ? cell.oldValue : null,
          entry: cell.entry || null,
        };
      })
      .reduce((acc, cell) => {
        acc[cell.key] = cell;
        return acc;
      }, {});
  });
}

export { getStageKey, notUndefinedOrNull, getSource, getContext, formatRowForRendering };
